import Section from "@components/Section";
import StrapiImage from "@components/StrapiImage";
import { getSerifClass, isInverted } from "@components/utilities";
import { Title } from "@justhome/react-ui";
import { ComponentSectionsHeroSecondaryV2 } from "@lib/generated/graphql";
import { FC } from "react";

type HeroSecondaryProps = {
  data: ComponentSectionsHeroSecondaryV2;
};

const HeroSecondary: FC<HeroSecondaryProps> = ({ data }) => {
  if (!data) {
    return null;
  }

  const { title, subTitle, image, background } = data;

  const inverted = isInverted(background);
  return (
    <Section
      section={data}
      className="flex flex-col-reverse m:grid grid-cols-12 gap-3xl m:gap items-center pb-3s m:min-h-[400px] mt-2m"
    >
      <div className="col-span-6">
        <Title
          inverted={inverted}
          serifClass={getSerifClass(background)}
          className="text-d2 mb-3s"
        >
          {title}
        </Title>
        <p className="text-body-1 m:max-w-[464px]">{subTitle}</p>
      </div>
      <div className="w-full col-span-6">
        <StrapiImage
          width="390"
          height="390"
          alt=""
          image={image}
          className="object-contain"
        />
      </div>
    </Section>
  );
};

export default HeroSecondary;
